import React from 'react';

import { DROPDOWN_KEY } from '../../constants/Dropdown';

import * as allConstructorsObj from './Constructors';

const allConstructors = Object.keys(allConstructorsObj).map(name => {
  // eslint-disable-next-line import/namespace
  return allConstructorsObj[name];
});
const constructorsByType = {};
for (const currentConstructors of allConstructors) {
  const menuTypes = Object.getOwnPropertySymbols(currentConstructors);
  for (const menuType of menuTypes) {
    constructorsByType[menuType] = currentConstructors[menuType];
  }
}

export function getDropdown(menuType, menuConfig) {
  return React.createElement(constructorsByType[menuType], menuConfig);
}

export function isDropdownTypeOpen(state, type) {
  const dropdownArray = state.dropdown.get(DROPDOWN_KEY);
  if (dropdownArray && Array.isArray(dropdownArray)) {
    return state.dropdown.get(DROPDOWN_KEY).indexOf(type) >= 0;
  }
  return null;
}
